import { CompanyStatus } from 'utils/constants'
import { ICompany } from 'components/Company/interface'
import { USER_TYPES } from './constants'

export const isAdOpsUser = (userType: string): boolean =>
  [
    USER_TYPES.adOpsAdmin,
    USER_TYPES.adOpsCommercialSuccessOperator,
    USER_TYPES.adOpsCustomerSupport,
    USER_TYPES.adOpsReadOnly,
    USER_TYPES.adOpsAccountExecutive
  ].includes(userType)

export const isCompletedCompany = ({ stages, status, typeOrigin }: ICompany) => {
  return (
    ((status === CompanyStatus.ACTIVATED || status === CompanyStatus.ACTIVE) &&
      stages.some(({ statusName }) => statusName === CompanyStatus.ACTIVE)) ||
    typeOrigin === 'SalesForce'
  )
}

export const isCompletingOnboarding = ({ stages, status, typeOrigin }: ICompany) => {
  return (
    status === CompanyStatus.ACTIVE &&
    !stages.some(({ statusName }) => statusName === CompanyStatus.ACTIVE) &&
    typeOrigin !== 'SalesForce'
  )
}

export const isActiveCompany = ({ idReferenceCompany, status }: ICompany) => {
  return (status === CompanyStatus.ACTIVATED || status === CompanyStatus.ACTIVE) && !!idReferenceCompany
}